export const DEFAULT = 'DEFAULT';
export const CUSTOM = 'CUSTOM';